import router from "~/router";
import store from "~/store";

router.afterEach(async (to) => {
  const meta = to.meta || {};
  const title = meta.title || "";
  const isBack = meta.isBack || false;
  const routeName = to.name || "";
  const isHeaderShow = meta.isHeaderShow;
  const noFooter = meta.noFooter;

  await store.dispatch("page/setTitle", title);
  await store.dispatch("page/setRouteName", routeName);
  await store.dispatch("page/setBack", isBack);
  await store.dispatch("page/setHeaderShow", isHeaderShow);  
  await store.dispatch("page/setNoFooter", noFooter);
});
